import { render, staticRenderFns } from "./ConfigWppContacts.vue?vue&type=template&id=20e3ffca"
import script from "./ConfigWppContacts.vue?vue&type=script&lang=js"
export * from "./ConfigWppContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports